<template>
  <div>
    <div class="mask">
      <div class="popupMessage">
        <div class="popupMessage-play">
          <div class="news">
            <p>{{$t('i.login.news')}}</p>
            <!--<a href="javascript:void(0)" @click="close">X</a>-->
            <span class="md-close" @click="close">×</span>
          </div>
          <div class="notice">
            <p v-html="newsObj.title"></p>
          </div>
          <div class="notificationContent">
            <div class="notificationContentPlay">
              <p v-html="newsObj.content">{{newsObj.content}}</p>
            </div>
            <div class="courseDetails">
              <course-details v-show ="is_show_course"  :newCourse="newCourse"></course-details>
            </div>
            <div  style="margin-top: -50px;text-align: center"><Button type="primary"  size="large"  @click="signUp">
              <template v-if="newsObj.type == '0' ">
                {{$t('i.courseware.signUp')}}
              </template>
              <template v-else>
                {{$t('i.system.study')}}
              </template>

            </Button></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CourseDetails from "../study/components/courseDetails";
  export default {
    name: "newsPopup",
    components: {CourseDetails},
    // data(){
    //   return{
    //     newsObj: {
    //       title: '234567',
    //       content: ''
    //     }
    //   }
    // },
    props:[
      "show",
      "newsObj",
      "is_show_course",
      "newCourse",
    ],
    methods:{
      close(){
        this.$emit('close')
      },
      signUp(){
        this.$router.push({name:'studyModel',query : {type:'newPerson', pname: '研修' }})
      }
    },
  }
</script>

<style scoped>
  .mask{
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,.10);
    top: 0;
    left: 0;
  }
  .popupMessage{
    width: 100%;
    height: 600px;
  }
  .popupMessage-play{
    width: 800px;
    height: 600px;
    margin: 50px auto 0 auto;
    border-radius: 20px;
    border: 1px solid #e92540;
    background-color: #fff;
  }
  .news{
    width: 800px;
    height: 70px;
    padding-top: 1px;
    border-bottom: 1px solid #e92540;
  }
  .md-close{
    font-size: 45px;
    float: right;
    margin-right: 30px;
    line-height: 70px;
    cursor: pointer;
    color: #2d8cf0;
  }

  .news p{
    float: left;
    display: inline;
    font-size: 30px;
    padding-top: 10px;
    padding-left: 38px;
  }
  .notice{
    width: 800px;
    height: 40px;
    overflow: hidden;
    margin-top: 5px;
  }

  .notice p{
    font-size: 24px;
    line-height: 40px;
    text-align: center;
  }

  .notificationContent{
    width: 798px;
    height: 470px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .notificationContentPlay{
    width: 780px;
    mix-height: 50px;
    height: auto;
    margin: 0 10px;
  }

  .notificationContent p{
    font-size: 18px;
    word-break: break-all;
    padding-top: 5px;
    line-height: 30px;
  }
  .courseDetails{
    width: 800px;
    height: 380px;
    margin-top: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/newsPopup/newsPopup.vue